import type { TrainingsQuery } from '~/types/academy/trainingsQuery';
import type { AcademyFilterState } from '~/types/academy/filters';
import {
    ACADEMY_TRAININGS_LISTING_DEFAULT_PAGE,
    ACADEMY_TRAININGS_LISTING_DEFAULT_PAGE_SIZE
} from '~/utils/academy/constants';

export type AcademyTrainingsListingFilters = Partial<TrainingsQuery> & {
    filterState?: AcademyFilterState;
};

export function buildAcademyTrainingsListingQuery(filters?: AcademyTrainingsListingFilters) {
    const { filterState, page, page_size, ...query } = filters ?? {};

    return serializeTrainingsListingFetchQuery(
        mergeTrainingsListingQuery(
            {
                ...query,
                page: page ?? ACADEMY_TRAININGS_LISTING_DEFAULT_PAGE,
                page_size: page_size ?? ACADEMY_TRAININGS_LISTING_DEFAULT_PAGE_SIZE
            },
            filterState
        )
    );
}

export function mapFilterStateToTrainingsListingQuery(filterState: AcademyFilterState): Record<string, string> {
    const params: Record<string, string> = {};

    for (const [code, state] of Object.entries(filterState)) {
        if (state.type === 'checkbox_filter') {
            if (!state.selectedKeys.length) {
                continue;
            }

            params[code] = state.selectedKeys.join(',');
        }
    }

    return params;
}

export function mergeTrainingsListingQuery(
    baseQuery: Record<string, string | number | boolean | string[] | undefined>,
    filterState?: AcademyFilterState
): Record<string, string | number | boolean | string[]> {
    const merged: Record<string, string | number | boolean | string[]> = {};

    for (const [key, value] of Object.entries(baseQuery)) {
        if (value === undefined || value === null || value === '') {
            continue;
        }

        merged[key] = value;
    }

    if (filterState) {
        Object.assign(merged, mapFilterStateToTrainingsListingQuery(filterState));
    }

    return merged;
}

export function serializeTrainingsListingFetchQuery(
    query: Record<string, string | number | boolean | string[] | undefined>
): Record<string, string | number | boolean | string[]> {
    const serialized: Record<string, string | number | boolean | string[]> = {};

    for (const [key, value] of Object.entries(query)) {
        if (value === undefined || value === null || value === '') {
            continue;
        }

        serialized[key] = value;
    }

    return serialized;
}
